export const asAlert = {
  data: `<svg width="10" height="20" viewBox="0 0 10 20" xmlns="http://www.w3.org/2000/svg">
  <path d="M0 0V11H3V20L10 8H6L9 0H0Z"/>
  </svg>
  `,
  name: 'alert',
};
